import React, { useState } from 'react'
import ReactDOM from 'react-dom'

interface ImageModalProps {
  imageUrl: string
  trigger: React.ReactNode
}

const ImageModal: React.FC<ImageModalProps> = ({ imageUrl, trigger }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsOpen(true)
  }

  const handleClose = () => setIsOpen(false)

  return (
    <>
      <span
        onClick={handleOpen}
        className="cursor-pointer transition-all duration-300 opacity-100 hover:opacity-75"
      >
        {trigger}
      </span>

      {isOpen &&
        ReactDOM.createPortal(
          <div
            onClick={handleClose}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}
          >
            <img
              src={imageUrl}
              alt="modal"
              style={{
                maxWidth: '90%',
                maxHeight: '90%',
                borderRadius: '8px',
                boxShadow: '0 0 10px #000',
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>,
          document.body
        )}
    </>
  )
}

export default ImageModal
